import { pick } from "rambda"
import addRowIndex from "@shared/utils/general/addRowIndex"
import { Variables } from "../../../../api/vehicles/filter"
import { AddedFleetEntry } from "../../../../api/fleet"
import { TableEntry } from "./types"
import { ManuallyResolveEntriesState } from "./manuallyResolveEntriesReducer"

export const hasUnresolvedEntries = (entries: ReadonlyArray<TableEntry>) => entries.some((entry) => !entry.vehicleId)

export const getmanuallyResolvedEntriesInitialState = (
  entries: ReadonlyArray<AddedFleetEntry>
): ManuallyResolveEntriesState => {
  const entriesWithRowIndex = addRowIndex(entries)
  return {
    entries: entriesWithRowIndex,
    hasUnresolvedEntries: hasUnresolvedEntries(entriesWithRowIndex),
  }
}

export const fieldHasAllPrerequisiteValues = (entry: AddedFleetEntry, prerequisiteFields: (keyof Variables)[]) => {
  const prerequisiteValues = Object.values(pick(prerequisiteFields, entry))
  if (prerequisiteFields.length !== prerequisiteValues.length) return false
  return prerequisiteValues.every((val) => !!val)
}
